import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/AmenityManageApi/AmenityManage";
import { validateForm } from "utils/validation";
import { AmenityRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddAmenityForm from "./Components/AddAmenityForm";
import fields from "../json/AmenityFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AmenityAdd = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => {
    if (field.name === "features") {
      return { ...acc, [field.name]: [] };
    }
    return { ...acc, [field.name]: "" };
  }, {});

  const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
    initialValues,
    AmenityRules
  );

  // Form submit handler
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();

      Object.entries(formValues).forEach(([key, val]) => {
        if (key === "features" && Array.isArray(val)) {
          // Separate file objects from features data
          const featuresWithoutFiles = val.map((f) => ({
            name: f.name,
            icon: f.icon && typeof f.icon === "object" ? null : (f.icon || null),
            icon_url: f.icon_url || null,
          }));
          formData.append(key, JSON.stringify(featuresWithoutFiles));

          // Append feature icon files as separate fields
          val.forEach((feature, index) => {
            if (feature.icon && typeof feature.icon === "object") {
              formData.append(`feature_icon_${index}`, feature.icon);
            }
          });
        } else if (key !== "imagePreview") {
          formData.append(key, val ?? "");
        }
      });

      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, AmenityRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Amenity created successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddAmenityForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        title="Create Amenity"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default AmenityAdd;
